import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDoupleCheckmark1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="douple-checkmark-1"><path d="M2.75 12.7768L7.92857 19.25L17.25 4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.7499 19.5L21.25 4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDoupleCheckmark1;
